import { NgModule } from '@angular/core'
import { RouterModule } from '@angular/router'
import { GlobalAdminEnforcementGuard } from './services/global-admin-enforcement/global-admin-enforcement.guard'

/*
 * FTR Web App Imports
 */
import { SyncGuard } from '@ftr/foundation'
import { AppPaths } from '@ftr/routing-paths'
import { SharedAuthRoutesModule } from '@ftr/ui-auth-routes'
import { NotFoundComponent } from '@ftr/ui-core'
import { HelpPageModule } from '@ftr/ui-help'
import {
  AuthenticationGuard,
  MultifactorAuthenticationPagesModule,
  PasswordResetPagesModule,
  SignupPagesModule,
} from '@ftr/ui-user'

@NgModule({
  imports: [
    NotFoundComponent,
    SharedAuthRoutesModule,
    SignupPagesModule,
    PasswordResetPagesModule,
    HelpPageModule,
    MultifactorAuthenticationPagesModule,
    RouterModule.forRoot([
      {
        path: AppPaths.DefaultPage,
        canActivate: [SyncGuard],
        data: {
          breadcrumb: 'Home',
          title: 'Home',
          syncGuards: [AuthenticationGuard, GlobalAdminEnforcementGuard],
        },
        children: [
          {
            path: AppPaths.DefaultPage,
            redirectTo: AppPaths.Admin,
            pathMatch: 'full',
          },
          {
            path: AppPaths.Admin,
            loadChildren: () => import('./pages/admin/global-admin-pages.module').then(m => m.GlobalAdminPagesModule),
          },
        ],
      },
      {
        path: '**',
        component: NotFoundComponent,
        canActivate: [AuthenticationGuard, GlobalAdminEnforcementGuard],
      },
    ]),
  ],
  exports: [RouterModule],
})
export class AppRoutingModule {}
